import { FlightDate } from "../../expense/flight-date";

export class setflightDate {
    flightDate: Array<FlightDate>;
    targetBudget: number;
    constructor (flightDate,targetBudget) {
        this.flightDate =  flightDate;
        this.targetBudget = targetBudget;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/info-expense/set-flight-date.ts